import React from "react";
import { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { format } from 'date-fns';
import html2pdf from "html2pdf.js";
import commonLabels from "../../../common/labels/common_en.json";
import label from "../../labels/interviewProcess_en.json";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
  getSubjectlistByExamId,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getAllDuplicateCodes
} from "../../actions/interviewProcessActions";
import { getYearList, getAdvertisementlistByYear } from "../../../common/actions/commonActions";


const DuplicateCodes = () => {

  const pdfRef = useRef(null);

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);

  const session = JSON.parse(sessionStorage.getItem("session"));
  const date = new Date(); // Your date object here
  const formattedDate = format(date, 'MM/dd/yyyy');

  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    onCancelButton();
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let { examList, advertisementList, subjectList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { getDuplicateCodeData } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + getDuplicateCodeData.examName + '</h5><h5>' + label.DUPLICATECODENO + '</h5><h5>' + getDuplicateCodeData.subjectName + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;


    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: 'Duplicate_Codes_List.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');
          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = getDuplicateCodeData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`Duplicate_Codes_List_${selectedExam}.pdf`);

      });
  };


  const onExamChange = (ele) => {
    let selectedValue = ele;
    subjectList.length = 0;
    setSelectedExam(selectedValue);
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    examList.length = 0;
    subjectList.length = 0;
    setSelectedExam("");
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };


  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton()
    }
    else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0
      }
      if (advertisementList) {
        advertisementList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }

  };


  const onSubjectChange = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    selectedValue && dispatch(getAllDuplicateCodes(selectedExam, selectedValue, setSaveButtonFlag));
    // setSaveButtonFlag(false);
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSelectedYear("");
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
    allYearList.length = 0;
    examList.length = 0;
    subjectList.length = 0;
  };

  return (
    <div className="dashboardContentArea">
      <h5> {label.DuplicateCodes} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear4"
                    value={selectedYear}
                    // ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option key={index}>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear4.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo4"
                    // value={selectedAdvertNo}
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo4.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>

                <div className=" col-md-3">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam4"
                    // value={selectedExam}
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedExam4.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className=" col-md-3">
                  <label className="float-left">
                    {label.SelectSubject}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedSubject4"
                    // value={selectedSubject}
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSubjectChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      subjectList &&
                      subjectList.length > 0 &&
                      subjectList
                        // .filter(
                        //   (element) =>
                        //     element.isDeleted == false &&
                        //     element.isActive === true
                        // )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}({element.type?.toUpperCase()})
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedSubject4.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              <div className="row"> 
                <div className=" col-md-8">
                  <button
                    type="reset"
                    className="btn btn-secondary mr-2"
                    onClick={() => onCancelButton()}
                  >
                    {commonLabels.BUTTON_CANCEL}
                  </button>

                  {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                    type="button"
                    className="btn btn-primary mr-2"
                    disabled={saveButtonFlag || !getDuplicateCodeData.descriptiveDuplicateNoListDtoes}
                    onClick={() => {
                      genPdf();
                    }}
                  >
                    {commonLabels.BUTTON_PRINT}
                  </button>}

                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
      {selectedSubject && getDuplicateCodeData && getDuplicateCodeData.descriptiveDuplicateNoListDtoes && getDuplicateCodeData.descriptiveDuplicateNoListDtoes.length > 0 && (
        <div ref={pdfRef}>
          <table className="table">
            <thead>
              <tr className="text-center">
                <th colSpan="5" className="marks-header">
                  <span>Examiner Marks</span><br />
                  <span>Moderator Marks</span>
                </th>
                <th colSpan="5" className="marks-header">
                  <span>Examiner Marks</span><br />
                  <span>Moderator Marks</span>
                </th>
              </tr>

              <tr>
                <th className="marks-cell">
                  <span>CODE</span><br />
                  <span>Sr. No.</span>
                </th>
                <th className="marks-cell">Q1</th>
                <th className="marks-cell">Q2</th>
                <th className="marks-cell">Q3</th>
                <th className="marks-cell">Total</th>

                <th className="marks-cell">CODE</th>
                <th className="marks-cell">Q1</th>
                <th className="marks-cell">Q2</th>
                <th className="marks-cell">Q3</th>
                <th className="marks-cell">Total</th>
              </tr>
            </thead>

            <tbody>
              {getDuplicateCodeData.descriptiveDuplicateNoListDtoes.map((item, index) => (
                <tr key={index}>
                  <td>
                    <strong>{item.code}</strong><br />
                    {item.serialNo}
                  </td>
                  <td>{item.examinerMarks}</td>
                  <td>{item.moderatorMarks || '-'}</td>
                  <td>{item.chiefModeratorMarks || '-'}</td>
                  <td>{item.total}</td>

                  <td>
                    <strong>{item.code}</strong>
                  </td>
                  <td>{item.examinerMarks}</td>
                  <td>{item.moderatorMarks || '-'}</td>
                  <td>{item.chiefModeratorMarks || '-'}</td>
                  <td>{item.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}<br /><br />
    </div>
  );
};

export default DuplicateCodes;
